import { store } from "../store";
import apiClientToken from "../plugins/axiosToken";
import Controller from "./Controller";

export default class Perifericos {
  getPerifericos(context,param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
            "WCFEquiposPerifericos.svc/RestService/Get/"+
            param
        )
        .then(function (response) {
          //console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  addPeriferico(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios +
            "WCFEquiposPerifericos.svc/RestService/Add",
          param
        )
        .then(function (response) {
          //console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  deletePeriferico(context, param,id_usuario) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios +
            "WCFEquiposPerifericos.svc/RestService/Delete/" +
            param+"/"+id_usuario
        )
        .then(function (response) {
          //console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  updatePeriferico(context, param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .post(
          store.getters.getUrlServicios +
            "WCFEquiposPerifericos.svc/RestService/Update",
          param
        )
        .then(function (response) {
          console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

  getPerifericosPorEquipo(context,param) {
    var t = context;
    var controller = new Controller();
    return new Promise(function (resolve, reject) {
      apiClientToken
        .get(
          store.getters.getUrlServicios +
            "WCFEquiposPerifericos.svc/RestService/GetPorEquiopoComputo/"+
            param 
        )
        .then(function (response) {
          //console.log(response.data.data);
          resolve(controller.getData(context, response));
        })
        .catch(function (error) {
          t.$toast.add({
            severity: "error",
            summary: "ERROR",
            detail: "Error al obtener datos del servidor",
            life: 3000,
          });
          console.log(error);
          reject(error);
        });
    });
  }

}
